import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { SystemService } from 'src/app/service/system.service';
import { AdmService } from 'src/app/service/adm.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-create-live-with',
  templateUrl: './create-live-with.component.html',
  styleUrls: ['./create-live-with.component.scss']
})
export class CreateLiveWithComponent implements OnInit {
  showLoader: boolean = false;
  creating: boolean = false;

  createLiveWith = new FormGroup({

    liveWithNameAr: new FormControl('', [
      Validators.required,
    ]),
    liveWithNameEn: new FormControl('', [
      Validators.required,
    ]),
    orderId: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(private admService:AdmService,private systemService: SystemService, private toastrService: ToastrService, public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService) { }

  ngOnInit(): void {
  }

  createLiveWithSubmit() {
    this.creating = true;
    if (this.createLiveWith.valid) {
      this.creating = true;
      this.admService.addLiveWith(this.createLiveWith.controls.liveWithNameAr.value, this.createLiveWith.controls.liveWithNameEn.value,  this.createLiveWith.controls.orderId.value)
        .subscribe(
          data => {
            this.router.navigate(['/admission/live-with']);
            this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
          },
          error => {
            this.creating = false
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          },
          () => this.creating = false
        );
    }
    else {
      this.toastrService.error(this.translate.instant('PLEASE_ENTER_REQUIRE_FIEDLS'));
      this.createLiveWith.markAllAsTouched();
      this.createLiveWith.markAsDirty();
      this.creating = false
    }
  }

  createLiveWithChange() {

    // this

  }

}
